/**
 * 全局主题管理模块
 * 支持狗、牛、猫三种主题
 * navBackground:导航栏短背景色
 * navLongBackground:导航栏长背景色
 * pageBackground:页面长背景色
 * pageShortBackground:页面短背景色
 * buttonBackground:健康指标带icon的按钮的背景色
 * iconColor :健康指标带icon的按钮的icon颜色
 * textColor :健康指标带icon的按钮的文字颜色
 * cardBackground:卡片背景色
 * btnBackground: 按钮背景色
 * btnDisabledBackground:按钮禁用背景色
 * btnPrimaryColor:线框btn-按钮文字颜色
 * btnPrimaryBorder:线框btn-按钮边框颜色
 * textColor:主题色-文案颜色
 * name:健康指标带icon的按钮的名称
 * duibiIconBgImg:对比页面背景图
 * topicBgImg:仿真-中医测评-题目背景图
 * themeIconImg:主题-宠物头icon图
 */

const themeConfig = {
    dogTheme: {
        navBackground: 'linear-gradient( 180deg, #FFF4E6 0%, #FFFAF3 100%)',
        navLongBackground:"linear-gradient( 180deg, #FFF3E4 0%, #FFF4E6 100%)",
        pageBackground: 'radial-gradient(circle at 30% 240px, rgba(255, 230, 201,1) 100px, transparent 200px),radial-gradient(circle at 80% 240px, rgba(255, 243, 207,1) 100px, transparent 200px),linear-gradient(180deg, #FFF9F0 0%, #FFFBF0 300px, #ffffff 100%)',
        pageShortBackground: 'linear-gradient( 180deg, #FFFAF3 0%, #FFFFFF 5%, #FFFFFF 100%)',
        pageLongBackground: 'linear-gradient( 180deg, #FFF4E6 0%, #FFFAF3 50%)',
        iconColor: '#F39043',
        textColor: '#222222',
        buttonBackground: 'linear-gradient( 106deg, #FFECD2 0%, #FFF5E2 100%)',
        cardBackground: 'linear-gradient(180deg, #FFFAEE 0%, #FFEDC5 100%)',
        btnBackground: 'linear-gradient( 154deg, #FFE69F 0%, #FF9E6F 100%)',
        btnDisabledBackground: 'rgba(255, 243, 227, 0.8)',
        duibiIconBgImg:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesEcharts/compare/bg-duibi-dog%402x.png",
        topicBgImg:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/evaluating/index/topic-bg-xiaogou%402x.png",
        // 按钮和文案字体配置
        btnPrimaryColor: '#FF7D3F',
        btnPrimaryBorder: '#FF7D3F',
        textColor: '#FF7D3F',
        name: '狗',
        themeIconImg:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/Theme/dogTheme-icon%402x.png",
    },
    cowTheme: {
        navBackground: 'linear-gradient( 180deg, #EFFBFF 0%, #F7FDFF 100%)',
        navLongBackground:"linear-gradient( 180deg, #E4FFFB 0%, #EFFBFF 100%)",
        pageBackground: 'radial-gradient(circle at 30% 240px, rgba(230, 255, 242,1) 100px, transparent 200px),radial-gradient(circle at 80% 240px, rgba(209, 255, 243,1) 100px, transparent 200px),linear-gradient(180deg, #E7FFFE 0%, #F2FFFE 300px, #ffffff 100%)',
        pageShortBackground: 'linear-gradient( 180deg, #F7FDFF 0%, #FFFFFF 5%, #FFFFFF 100%)',
        pageLongBackground: 'linear-gradient( 180deg, #EFFBFF 0%, #F7FDFF 50%)',
        iconColor: '#58CEE0',
        textColor: '#222222',
        buttonBackground: 'linear-gradient( 106deg, #DDFFF2 0%, #E2FEFF 100%)',
        cardBackground: 'linear-gradient(180deg, #F0F8FF 0%, #E6F3FF 100%)',
        btnBackground: 'linear-gradient( 139deg, #A0FFDF 0%, #7CE4FF 100%)',
        btnDisabledBackground: 'rgba(227, 255, 255, 0.8)',
        duibiIconBgImg:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesEcharts/compare/bg-duibi-cow%402x.png",
        topicBgImg:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/evaluating/index/topic-bg-xiaoniu%402x.png",
        // 按钮和文案字体配置
        btnPrimaryColor: '#0DD1FF',
        btnPrimaryBorder: '#0DD1FF',
        textColor: '#0DD1FF',
        name: '牛',
        themeIconImg:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/Theme/cowTheme-icon%402x.png",
    },
    catTheme: {
        navBackground: 'linear-gradient( 180deg, #EBFFF5 0%, #F9FFFD 100%)',
        navLongBackground: 'linear-gradient( 180deg, #E4FFEB 0%, #EBFFF5 100%)',
        pageBackground: 'radial-gradient(circle at 30% 240px, rgba(209, 255, 240,1) 100px, transparent 200px),radial-gradient(circle at 80% 240px, #E6FFEF 100px, transparent 200px),linear-gradient(180deg, #e6ffef 0%, #ffffff 300px, #ffffff 100%)',
        pageShortBackground: ' linear-gradient( 180deg, #F9FFFD 0%, #FFFFFF 5%, #FFFFFF 100%)',
        pageLongBackground: 'linear-gradient( 180deg, #EBFFF5 0%, #F9FFFD 50%)',
        iconColor: '#97E23F',
        textColor: '#222222',
        buttonBackground: 'linear-gradient( 106deg, #E4FFDD 0%, #E2FFEB 100%)',
        cardBackground: 'linear-gradient(180deg, #F3FFEE 0%, #FFFEF5 100%)',
        btnBackground: 'linear-gradient( 177deg, #7DFFED 0%, #9EFD40 100%)',
        btnDisabledBackground: 'rgba(229, 255, 227, 0.8)',
        duibiIconBgImg:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesEcharts/compare/bg-duibi%402x.png",
        topicBgImg:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/evaluating/index/topic-bg.png",
        // 按钮和文案字体配置
        btnPrimaryColor: '#65AF24',
        btnPrimaryBorder: '#65AF24',
        textColor: '#65AF24',
        name: '猫',
        themeIconImg:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/Theme/catTheme-icon%402x.png",
    }
};

const state = {
    // 当前激活的主题
    currentTheme: uni.getStorageSync('currentTheme') || 'catTheme',
    // 主题配置
    themeConfig: themeConfig
};

const getters = {
    // 获取当前主题配置
    currentThemeConfig: (state) => {
        return state.themeConfig[state.currentTheme] || state.themeConfig.catTheme;
    },
    
    // 获取当前主题按钮样式
    themeButtonStyle: (state, getters) => {
        return {
            background: getters.currentThemeConfig.buttonBackground,
            color: getters.currentThemeConfig.textColor
        };
    },
    
    // 获取当前主题图标颜色
    themeIconColor: (state, getters) => {
        return getters.currentThemeConfig.iconColor;
    },
    
    // 获取当前主题页面背景样式
    themePageBackground: (state, getters) => {
        return {
            background: getters.currentThemeConfig.pageBackground
        };
    },
    
    // 获取当前主题卡片背景样式
    themeCardBackground: (state, getters) => {
        return {
            background: getters.currentThemeConfig.cardBackground
        };
    },
    
    // 获取所有可用主题列表
    availableThemes: (state) => {
        return Object.keys(state.themeConfig).map(key => ({
            key,
            name: state.themeConfig[key].name,
            config: state.themeConfig[key]
        }));
    }
};

const mutations = {
    // 设置当前主题
    SET_CURRENT_THEME(state, themeName) {
        if (state.themeConfig[themeName]) {
            state.currentTheme = themeName;
            // 持久化存储主题设置
            uni.setStorageSync('currentTheme', themeName);
        }
    },
    
    // 添加或更新主题配置
    UPDATE_THEME_CONFIG(state, { themeName, config }) {
        if (themeName && config) {
            state.themeConfig[themeName] = { ...state.themeConfig[themeName], ...config };
        }
    },
    
    // 重置主题为默认
    RESET_THEME(state) {
        state.currentTheme = 'catTheme';
        uni.setStorageSync('currentTheme', 'catTheme');
    }
};

const actions = {
    // 切换主题
    switchTheme({ commit, state }, themeName) {
        if (state.themeConfig[themeName]) {
            commit('SET_CURRENT_THEME', themeName);
            
            // 触发全局主题变化事件（如果需要）
            uni.$emit('themeChanged', {
                oldTheme: state.currentTheme,
                newTheme: themeName,
                config: state.themeConfig[themeName]
            });
            
            return Promise.resolve(state.themeConfig[themeName]);
        }
        return Promise.reject(new Error(`主题 ${themeName} 不存在`));
    },
    
    // 切换到下一个主题
    switchToNextTheme({ commit, state, getters }) {
        const themes = Object.keys(state.themeConfig);
        const currentIndex = themes.indexOf(state.currentTheme);
        const nextIndex = (currentIndex + 1) % themes.length;
        const nextTheme = themes[nextIndex];
        
        commit('SET_CURRENT_THEME', nextTheme);
        return getters.currentThemeConfig;
    },
    
    // 初始化主题（从存储中恢复）
    initTheme({ commit }) {
        const savedTheme = uni.getStorageSync('currentTheme');
        if (savedTheme) {
            commit('SET_CURRENT_THEME', savedTheme);
        }
    },
    
    // 自定义主题配置
    customizeTheme({ commit }, { themeName, config }) {
        commit('UPDATE_THEME_CONFIG', { themeName, config });
        return Promise.resolve();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
